import { HttpClient, HttpRequest } from "@/domain/clients";
import { AxiosInstance } from "axios";

export class AxiosHttpClient implements HttpClient {
  constructor(private readonly axiosInstance: AxiosInstance) {}

  async request<T = any>(data: HttpRequest): Promise<T> {
    try {
      return this.axiosInstance.request({
        url: data.url,
        method: data.method,
        data: data.body,
        headers: data.headers,
        params: data.params,
      });
    } catch (error) {
      throw error;
    }
  }
}
